import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/business/businessUser";

class BusinessUserService {
  fetchBusinessUserInfo = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/me`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { businessUser } = response.data.data;
      return businessUser;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching user's info.");
    }
  };

  getInvitationLink = async (id) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/invitation-link/${id}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { invitationLink } = response.data.data;
      return invitationLink;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching user's info.");
    }
  };

  setUserLang = async (lang) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/lang`, { lang });
      if (response.status !== 200) {
        throw new Error();
      }
    } catch (err) {
      throw handleError(err, "Error occurred while setting users language.");
    }
  };

  getCustomers = async ({ page, search }) => {
    if (!search) {
      search = "";
    }

    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/users?page=${page}&search=${search}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, maxReached, total, perPage } = response.data;
      return {
        data,
        total,
        perPage,
        maxReached,
      };
    } catch (err) {
      throw handleError(err, "Error occurred while fetching customers.");
    }
  };

  createCustomer = async (requestData) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/create-user`,
        requestData
      );
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating customer.");
    }
  };

  adminLoginToBusinessUser = async (businessUserId) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/login/${businessUserId}`
      );
      if (response.status !== 201) {
        throw new Error();
      }
      const { accessToken, refreshToken, businessUser } = response.data.data;

      return { accessToken, refreshToken, businessUser };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while logging in, status:" + err.code
      );
    }
  };

  getAllBusinessUserRoles = async (page) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/business-roles?page=${page}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching business user roles."
      );
    }
  };

  addRoleToUser = async (body) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/add-business-roles`,
        body
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while adding role to business user."
      );
    }
  };

  createBusinessUserRole = async (body) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/business-roles`,
        body
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating business role.");
    }
  };

  updateBusinessUserRole = async ({ id, body }) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/business-roles/${id}`,
        body
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating business role.");
    }
  };
}

const businessUserService = new BusinessUserService();

export default businessUserService;
